module.exports = __webpack_public_path__ + "newprotal/img/index-pic2.08088dd1.png";